import Storage, { StorageKeys } from "../Storage";

const getAuthUserRole = ( ) => {
    const storage = new Storage();
    const roleId = storage.getItem(StorageKeys.RoleId) || '';
    return roleId;
};

export default getAuthUserRole;